<template>
  <div class="form-group mt-5">
    <div
      class="form-select form-control hasValue"
      :class="{ invalid: isInvalid() }"
    >
      <span class="w-100 text-truncate d-inline-block">{{
        getActiveTitle
      }}</span>
      <select
        :noTitle="true"
        :name="id"
        v-validate="config.Validation"
        ref="item"
        :value="value"
        @change="update()"
        autocomplete="off"
      >
        <option
          v-for="(item, i) in options"
          :key="i"
          :name="id"
          :value="item.Value"
        >
          {{ item.Title }}
        </option>
      </select>
    </div>
    <label
      class="form-control-placeholder"
      :for="'input' + id"
      v-if="isNoTitle()"
    >
      {{ config.Placeholder }}
      <span class="required-star" v-if="config.Placeholder">*</span>
    </label>
    <InfoText v-if="config.Info" :content="config.Info" :id="id" />
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ this.config.ErrorMessage }} skal udfyldes.
    </div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';

  export default {
    components: { InfoText },
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'options', 'config', 'id', 'noTitle'],
    methods: {
      update() {
        const valueAsNumber = Number(this.$refs.item.value);
        const value = isNaN(valueAsNumber)
          ? this.$refs.item.value
          : valueAsNumber;
        this.$emit('input', value);
        this.$emit('getNewData');
        this.$emit('setSelected');
      },
      selectOnlyOption() {
        this.$emit('input', this.options[0].Value);
        this.$emit('setSelected');
        setTimeout(() => {
          this.$validator.validate();
        }, 0);
      },
      setDefault() {
        this.$emit('input', this.options[0].Value);
        this.$emit('getNewData');
        this.$emit('setSelected');
        setTimeout(() => {
          this.$validator.validate();
        }, 0);
      },
      setStudentAsStandard() {
        this.$emit('input', this.options[0].Value);
        this.$emit('getNewData');
        this.$emit('setSelected');
        setTimeout(() => {
          this.$validator.validate();
        }, 0);
      },
      isNoTitle() {
        if (this.noTitle == false) {
          return false;
        }
        return true;
      },
      isInvalid() {
        return (
          this.$store.state.componentIsInvalid &&
          this.value == '' &&
          this.config.Validation.required
        );
      },
    },
    watch: {
      options: function () {
        // watch it
        if (this.options.length == 1) {
          // First on is "Vælg" placeholder
          this.selectOnlyOption();
        }
      },
    },
    computed: {
      getActiveTitle() {
        let activeEl = this.value;
        for (let index = 0; index < this.options.length; index++) {
          if (this.options[index].Value == this.value) {
            activeEl = this.options[index].Title;
          }
        }

        return activeEl;
      },
    },
    mounted() {
      // There is only one option, so select it
      if (this.options.length == 1) {
        this.selectOnlyOption();
      }
    },
  };
</script>
<style lang="scss" scoped>
  select option:first-child {
    display: none;
  }
</style>
